<template>
  <button
    class="desktop-btn btn btn-md px-3 py-2 btn-outline-light"
    @click="emit('click')"
  >
    <span class="material-symbols-outlined">{{ props.icon }}</span>
    <span class="desktop-btn-text">
      {{ props.label }}
    </span>
  </button>
  <span
    class="mobile-btn material-symbols-outlined fw-medium text-light"
    @click="emit('click')"
  >
    {{ props.icon }}
  </span>
</template>

<script lang="ts" setup>
const props = defineProps<{
  label: string;
  icon: string;
}>();
const emit = defineEmits(['click']);
</script>

<style>
.btn.desktop-btn {
  display: none;
  @media screen and (min-width: 992px) {
    display: flex;
  }
  .desktop-btn-text {
    margin: 0 0.25rem;
  }
}
.material-symbols-outlined.mobile-btn {
  display: flex;
  @media screen and (min-width: 992px) {
    display: none;
  }
}
</style>
